import React from 'react'
import Layout from '../../../../../component/layout/Layout'
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const FrictionTester = () => {
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 1000
    };

    const images = [
        '/img/instruments/friction_tester.png',
        '/img/instruments/friction_tester.png'
    ];

    return (
        <Layout>
            <div className="bread">
                <ul className="collapsed">
                    <li><a href="/">Home</a></li>
                    <li><a href="/packaingtesting">Packaging Testing</a></li>
                </ul>
            </div>
            <div className="container">
                <div className="section-title text-center" style={{ marginBottom: '2rem' }}>
                    <h1>Friction Tester</h1>
                </div>
            </div>
            <section id="portfolio-details" className="portfolio-details" style={{ backgroundColor: 'white', marginBottom: '12rem' }}>
                <div className="container">
                    <div className="row gy-4">
                        <div className="col-lg-8">
                            <div className="portfolio-details-slider swiper">
                                <Slider {...settings}>
                                    {images.map((src, index) => (
                                        <div className="swiper-slide" key={index}>
                                            <div className="img" style={{ alignItems: 'center' }}>
                                                <img src={src} alt="" className="responsive" />
                                            </div>
                                        </div>
                                    ))}
                                </Slider>
                                <div className="swiper-pagination"></div>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="portfolio-info" style={{ backgroundColor: 'white' }}>
                                <h3 className='pageheading'>Friction Tester</h3>
                                <p className='descriptionHead' style={{ textAlign: 'justify' }}>
                                    With a one column test framework designed to quickly and accurately determine Static and Dynamic
                                    Coefficients of Friction in samples of Paper, Cardboard, Plastic Film or similar material. The
                                    friction gauge is based on a mobile skate dragged by a highly accurate force measurement
                                    dynamometer system. Thanks to the high precision and repeatability of the results, this
                                    equipment can be used in R&D (Research and Development) to analyze the friction properties of
                                    previously mentioned materials or similar materials, under perfectly controlled test conditions.

                                    <a
                                        href="mailto:inst@rmc.in?subject=Inquiry about Fiber Potential Online (FPO)"
                                        style={{ color: '#0d6efd', fontWeight: '600', textDecoration: 'underline' }}
                                    >
                                        More Info
                                    </a>
                                </p>
                            </div>
                            <div className="portfolio-description"></div>
                        </div>
                    </div>
                </div>
            </section>
        </Layout>
    )
}

export default FrictionTester
